var BaseView = require('../../components/accordion-list/content');

module.exports = BaseView.extend({
  page: 0,

  initDataLoading: function () {
    this.end && this.end();
    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
  },

  initAuthenticatedDataLoading: function () {
    this.authenticated = true;
    BaseView.prototype.initDataLoading.call(this);
  },

  authenticate: function () {
    var deferred = $.Deferred();

    this.authenticated && deferred.resolve();
    this.authenticated || window.gdAsynInit(_.bind(function (success) {
      if (success) {
        this.initAuthenticatedDataLoading();
        deferred.resolve();
      } else {
        this.trigger('no_access');
        INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
        deferred.reject();
      }
    }, this));

    return deferred.promise();
  },

  loadData: function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    this.imagesFactory.getGooglePhotos({ page: this.page++ }, this.onMoreData);
  },

  onMoreData: function (status, imagesData, data) {
    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    if (!status || !data.length) { this.end(); return; }

    var callback = _.bind(this.tool.callbackImages, this.tool);
    this.tool.addThumbItem(this.$el, this.extractData(imagesData, data), callback);
    this.scrollRefresh();
    this.repeat();
  },

  getScrollHeight: function ($target) {
    var marginTop = 65;
    return $target.closest('.add').height() - marginTop;
  },

  extractData: function (imagesData, data) {
    return _.map(data, function (item) {
      return {
        id: 'photo-gd-' + item.object_id,
        src: item.src,
        data: imagesData[item.src_big]
      };
    });
  }
});
